import { styled } from "@styles";

export const TextStyle = styled("p", {
  fontWeight: "$medium",
  lineHeight: "$short",
  margin: 0,
  color: "$neutral70",

  variants: {
    variant: {
      black: {
        color: "$neutral100",
      },
      blue: {
        color: "$blue40",
      },
      lightGray: {
        color: "$neutral40",
      },
      silver: {
        color: "$neutral50",
      },
      gray: {
        color: "$neutral60",
      },
      mediumGray: {
        color: "$neutral70",
      },
      darkGray: {
        color: "$neutral80",
      },
      veryDarkGray: {
        color: "$neutral90",
      },
      green: {
        color: "$green40",
      },
      darkGreen: {
        color: "$green60",
      },
      red: {
        color: "$red40",
      },
      white: {
        color: "$white",
      },

      success: {
        color: "$green40",
      },
      warning: {
        color: "$yellow40",
      },
      info: {
        color: "$blue40",
      },
      danger: {
        color: "$red40",
      },

      description: {
        fontWeight: "$regular",
        fontSize: "1rem",
        lineHeight: "1.5rem",
        color: "$neutral50",
      },
      subtitle: {
        fontWeight: "$medium",
        fontSize: "0.75rem",
        lineHeight: "1rem",
        color: "$neutral60",
      },
    },

    weight: {
      heavy: {
        fontWeight: "$bold",
      },
      bold: {
        fontWeight: "$bold",
      },
      "semi-bold": {
        fontWeight: "$bold",
      },
      medium: {
        fontWeight: "$medium",
      },
      regular: {
        fontWeight: "$regular",
      },
      light: {},
    },

    size: {
      "large-2": {
        fontSize: "$24px",
        lineHeight: "$32px",
      },
      large: {
        fontSize: "$20px",
        lineHeight: "$24px",
      },
      "semi-large": {
        fontSize: "$18px",
        lineHeight: "$24px",
      },
      medium: {
        fontSize: "$16px",
        lineHeight: "$24px",
      },
      small: {
        fontSize: "$12px",
        lineHeight: "$16px",
      },
      "small-2": {
        fontSize: "$14px",
        lineHeight: "$24px",
      },
      "x-small": {
        fontSize: "$12px",
        lineHeight: "$16px",
      },
      "xx-small": {
        fontSize: "$10px",
        lineHeight: "$16px",
      },
    },

    crossed: {
      true: {
        textDecoration: "line-through",
      },
    },

    inline: {
      true: {
        display: "inline",
      },
    },
  },

  defaultVariants: {
    size: "medium",
    weight: "regular",
  },
});
